import { Status } from 'src/api/constants';
import { fetch } from 'src/api/fetchWrapper/fetch';

export const postTimetableRequest = async <T>(url: string, body: string, fallbackMessage: string): Promise<T> => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    const json = await response.json();

    if (response.status !== Status.CREATED) {
      const hasErrorMsg = !!json && typeof json === 'object' && 'message' in json && typeof json.message === 'string';
      throw new Error(hasErrorMsg ? json.message : fallbackMessage);
    }

    return json.data[0];
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error(`${fallbackMessage} (unexpected error calling ${url}: ${String(error)})`);
  }
};
